import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import api from './middleware/api';
import logging from './middleware/logging';
import LoggerWrapper from './lib/LoggerWrapper';
import rootReducer from './reducers';

LoggerWrapper.initialize();

const store = createStore(
    rootReducer,
    applyMiddleware(thunkMiddleware, api, logging, LoggerWrapper.reduxMiddleware())
);

export default store;